import $ from '../_snowpack/pkg/jquery.js';
import { Capacitor } from '../_snowpack/pkg/@capacitor/core.js';

(async () => {
  const isNative = Capacitor.isNative;  // check for mobile
  const ROOT = isNative ? 'https://hipster.io' : '';  // use diffrent url for web vs mobile
  const response = await fetch(`${ROOT}/json/menu.json`).then(response => response.json());// http request for menu
  const params = new URLSearchParams(window.location.search);// get all  url params
  const param = params.get('c');// get 'c' param
  const cat = response.menu.find((o) => o.cat === param);// get menu items from json that matches the url params

  if (cat) { // if found
    Object.keys(cat.subs).forEach(sub => {  // loop through sub category
      const text = response.submenu[sub]; // get txt from sub menu item
      const root = isNative ? '/index.html' : ''; // mobile specific url
      $('.action-btn-container').append($(`<a href='/map${root}?g=${sub}' class='${sub}'>`).html(
        `<img src="/fin/groups/${sub}.png" />
        <h3>${text.name}</h3>`
      ));
    });
  } else {
    window.location.href = '/'; // if not found send them to root
  }

  $('.action-btn-container').animate({ opacity: 1 }); // fade in on load
  $('img').css('opacity', .1).each( function(){ // set imgs to low opacity
      $(this).on('load', function () { // on load fade in fully
          $(this).animate({ opacity: 1 });
      });
  });
})();
